import axiosClient from "./axiosClients";

const uri = "/auth";

class AuthApi {
  login = (data) => {
    const url = `${uri}/login`;
    return axiosClient.post(url, data);
  };
}
const authApi = new AuthApi();
export default authApi;
